import React from 'react';
import { Link } from 'react-router-dom';
import { FaBuilding, FaCogs, FaHospital, FaUserShield } from 'react-icons/fa';

const modules = [
  'Scheduling',
  'Clinical Outcomes',
  'Research Studies',
  'Publication Research',
  'Dictation',
];

const AdminDashboard: React.FC = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-base-content flex items-center gap-3">
          <FaUserShield className="text-primary" />
          Global Administration
        </h1>
        <p className="text-base-content opacity-70 mt-2">
          Configure tenants, facilities, subscriptions, and module access.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <div className="card bg-base-100 shadow">
          <div className="card-body">
            <h2 className="card-title flex items-center gap-2">
              <FaBuilding className="text-primary" />
              Clients
            </h2>
            <p className="text-sm text-base-content opacity-70">
              Add and manage clients, tenant configuration, and access.
            </p>
            <div className="card-actions justify-end">
              <Link to="/admin/clients" className="btn btn-primary btn-sm">
                Open Client Admin
              </Link>
            </div>
          </div>
        </div>

        <div className="card bg-base-100 shadow">
          <div className="card-body">
            <h2 className="card-title flex items-center gap-2">
              <FaHospital className="text-primary" />
              Facilities
            </h2>
            <p className="text-sm text-base-content opacity-70">
              Manage facility records and cross-facility governance.
            </p>
            <div className="card-actions justify-end">
              <Link to="/facilities/facilities" className="btn btn-outline btn-sm">
                Open Facilities
              </Link>
            </div>
          </div>
        </div>

        <div className="card bg-base-100 shadow">
          <div className="card-body">
            <h2 className="card-title">Subscriptions</h2>
            <p className="text-sm text-base-content opacity-70">
              Subscription plans, billing tiers, and entitlement controls.
            </p>
            <div className="card-actions justify-end">
              <button className="btn btn-ghost btn-sm" disabled>
                Coming Soon
              </button>
            </div>
          </div>
        </div>

        <div className="card bg-base-100 shadow">
          <div className="card-body">
            <h2 className="card-title flex items-center gap-2">
              <FaCogs className="text-primary" />
              Module Access
            </h2>
            <p className="text-sm text-base-content opacity-70">
              Enable or disable modules per client and policy.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-2">
              {modules.map((moduleName) => (
                <label key={moduleName} className="label justify-between bg-base-200 rounded px-3 py-2">
                  <span className="label-text">{moduleName}</span>
                  <input type="checkbox" className="toggle toggle-primary toggle-sm" disabled />
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
